import { OAuthStorage } from "angular-oauth2-oidc";

export class IdentityAuthStorage extends OAuthStorage {
    
    _storage: Storage;
    _prefix: string = "";

    constructor(storage: Storage, prefix: string = "") {
        super();

        this._storage = storage;
        this._prefix = prefix + "_";
    }

    private makeKey(key: string): string {
        return this._prefix + key;
    }

    getItem(key: string): string | null {
        return this._storage.getItem(this.makeKey(key));
    }

    removeItem(key: string): void {
        this._storage.removeItem(this.makeKey(key));
    }

    setItem(key: string, data: string): void {
        this._storage.setItem(this.makeKey(key), data);
    }
}